// @ts-nocheck

export const API = {
  AUTH: {
    LOGIN: `/account/api/auth/login`,
    REGISTER: `/account/api/auth/register`,
    REFRESH: `/account/api/auth/refresh`,
    FORGOTPASSWORD: `/account/api/auth/passwordreset`,
    CHANGEPASSWORD: '/sis-core/api/customer/reset/password',
    VERIFYPASSWORD: '/sis-core/api/customer/verify/password',
  },
  PAYMENT: {
    APPID: 'payment/api/app_master',
    GATEWAYLIST: 'payment/api/gateway',
    INITIATETRANSACTIONCORE: 'sis-core/api/enroll-payment',
    INITIATETRANSACTIONCOREFUNDED: 'sis-core/api/enroll-pre-payment',
    INITIATERETRANSACTIONCORE: 'sis-core/api/re-enroll-payment',
    PREPAYMENT: 'sis-core/api/pre-payment',
    INACTIVE_SUBSCRIPTION_PREPAYMENT: 'sis-core/api/subscription/continue',
    FETCHTRANSACTIONSTATUS: 'sis-core/api/transaction/detail',
    FETCHTRANSACTIONDETAILS: 'sis-core/api/transactionByTxnId',
    FETCHWALLET: 'sis-core/api/transaction/wallet/points',
    FETCHWALLETTRANSACTIONS: 'sis-core/api/transaction/wallet/list',
    FETCHENROLLMENTRECURRINGDETAILS: 'sis-core/api/enrollment-recurring-details',
    INVOICERECURRINGDETAILS: 'sis-core/api/invoice-recurring-details',
    FETCHENROLLMENTRECURRINGCARDDETAILS: 'sis-core/api/enrollment/subscription-details',
    UPDATECARDDETAILS: 'sis-core/api/enroll-payment-update',
    ADDWALLETPOINT: 'payment/api/transaction-wallet',
    FETCHWALLETSTATUS: 'payment/api/transaction-status',
    ADDITIONALFEE: 'sis-core/api/additional-fee/addFeePayment',
    TRANSACTIONFAILUREDETAILS: 'sis-core/api/transaction-charge-detail',
    VERIFY_VOUCHER: '/sis-core/api/verifyVoucher',
  },
  CORE: {
    SLUG: '/sis-core/api',
    MASTER: '/sis-core/api/enums',
    EXTENSION_REQUEST: 'sis-core/api/additional-fee/request-extension',
    SECURITYQUESTIONS: '/sis-core/api/security-question',
    METADATA: '/sis-core/api/general-info/meta-data-school',
    ENROLLMENT: '/sis-core/api/user-program',
    ALLPROGRAMS: '/sis-core/api/all-program',
    PROGRAM: '/sis-core/api/program',
    COURSEDETAILOPEN: '/sis-core/api/user-coursedetail',
    ENROLLMENTDETAIL: '/sis-core/api/user-enrolled-program',
    ENROLLMENTFEE: '/sis-core/api/student-enrollment-fee',
    REENROLLMENTFEE: '/sis-core/api/reEnrFee',
    ENROLLPROGRAM: '/sis-core/api/enroll',
    UPDATEENROLLPROGRAM: '/sis-core/api/enroll-course',
    ENROLLMENTCOURSES: '/sis-core/api/enrollment-course',
    TRANSACTION: '/sis-core/api/transaction',
    TEMPLATES: '/sis-core/api/get-template-content',
    PUBLIC_TEMPLATES: 'sis-core/api/get-public-template-content',
    PAYMENT_LEDGER: '/sis-core/api/student-payment-ledger',
    DOWNLOAD_PAYMENT_LEDGER: '/sis-core/api/downloadStudentPaymentLedger-pdf',
    DOWNLOAD_INVOICE: '/sis-core/api/downloadStudentInvoice-pdf',
    SUBMISSIONS: '/easy-grader/api/verifier',
    DROPENROLLMENT: '/sis-core/api/enrollment/dropRequest',
    DOWNLOADTRANSCRIPT: '/sis-core/api/student-download-pdf',
    ANNOUNCEMENTS: 'sis-core/api/getStudentAndParent',
    ANNOUNCEMENT_DETAIL: 'sis-core/api/announcement',
    DOWNLOADENROLLMENTAGREEMENT: '/sis-core/api/downloadEnrollmentAgreement-pdf',
    DOWNLOADENROLLMENDROPPDF: '/sis-core/api/downloadEnrollmentDrop-pdf',
    ADMINUSERDETAIL: '/sis-core/api/user/principal',
    PARENT: '/sis-core/api/parent',
    CHILDREN_LIST: '/sis-core/api/parent/children/v1',
    ENROLLMENTPROGRAMS: '/sis-core/api/enrolled-prior-program',
    ENROLLMENTS_WITH_PROGRESS: '/sis-core/api/enrolled-prior-program-courses',
    PRIORCOACHES: '/sis-core/api/prior-coaches',
    UPLOADFILES: '/sis-core/api',
    FERPA: '/sis-core/api/ferpa',
    DOWNLOADTRANSACTION: '/sis-core/api/customer-download-pdf-transaction',
    PROGRAMCATEGORY: 'sis-core/api/program-category',
    PROGRAMCATEGORY: 'sis-core/api/program-category',
    POSTGRADPLANQUESTIONS: 'sis-core/api/get-questions-options',
    ADD_ONS: 'sis-core/api/student-program-getAll',
    ADD_ONS_LISTING: 'sis-core/api/student-order-listing',
    ADD_ONS_DETAIL: 'sis-core/api/student-order-details',
    POSTGRADPLANQUESTIONRESPONSE: 'sis-core/api/get-questions-response',
    UPDATEPOSTGRADPLANQUESTIONRESPONSE: 'sis-core/api/enroll/qa',
    QUIZZES: 'sis-core/api/lms/course/students/submissions',
    SERVICEPROVIDER: 'sis-core/api/lms/canvas/service-provider-list',
    SUMMARY: '/sis-core/api/enrollment/enrollmentSummary',
    SUMMARYWITHPROGRESS: '/sis-core/api/enrollment/enrollmentSummaryv1',
    ADDITIONALFEE: '/sis-core/api/additional-fee',
    REENROLLMENTS: '/sis-core/api/re-enroll',
    REENR: '/sis-core/api/re-enr',
    SUBSCRIPTION_VERIFY: '/sis-core/api/subscription/verify',
    SMS_SETTINGS: '/sis-core/api/sms/enable',
    GENERATE_OTP: '/sis-core/api/sms/otp',
    VERIFY_OTP: '/sis-core/api/sms/otpVerify',
    SMS_INFO: '/sis-core/api/sms/enable/info',
    LOGIN_AS: 'sis-core/api/loginAsCustomer',
    LOGINEVENTS: '/sis-core/api/customer-events/type',
    CANVASHISTORY: '/sis-core/api/canvaslist',
    LASTATTENDANCE: '/sis-core/api/canvas/page_view',
    TOUR: '/sis-core/api/user-tour',
    GRADE_FETCH: 'sis-core/api/canvas/map-enrollment-course-grade-fetchv1',
    SCHOOL_STORES: '/sis-core/api/store-config',
    GUEST_SCHOOL_STORES: '/sis-core/api/guest-store-config',
    SCHOOL_STORES_ADDON: '/sis-core/api/additional-fee/school-store-purchase',
    GUEST_CHECKOUT: 'sis-core/api/guest-checkout',
    PENDING_ENROLLMENTS: 'sis-core/api/incomplete-enrollment-detail',
    ENROLLMENTS_WITH_STATUS: 'sis-core/api/get-student-dashboard',
    CONCLUDE_COURSE: '/sis-core/api/mark-course-completed-user',
    LMS_CONFIG: '/sis-core/api/school-active-lms-config',
    ENROLLMENT_RATING_LIST: '/sis-core/api/enrollment-rating',
    COURSES_RATING_LIST: '/sis-core/api/course-rating',
    INTERNAL_SSO: '/sis-core/api/internal-sso',
    STATE_INVOICES: 'sis-core/api/student-enrollment-invoices',
  },
  RATING_REVIEW: {
    CREATE_RATING_REVIEW: '/rating-review/api/student-rating-review',
    CREATE_PUBLIC_RATING_REVIEW: '/rating-review/api/student-rating-review/public-rating-review',
    RATING_REVIEW: '/rating-review',
  },

  NOTIFICATION: {
    notification: `/sis-core/api/notification/receiver`,
  },

  MEDIAMANAGER: {
    MEDIA: '/media-manager',
  },
  // MEDIARESPONSE: '/media-manager/api/access/',
  tms: {
    ticketManager: '/sis-core/api/ticket',
  },
  event: {
    events: '/sis-core/api/get-events',
    eventDetail: '/sis-core/api/events',
    category: '/sis-core/api/category/list',
  },
  CUSTOMER: '/sis-core/api/customer',
  PARENT: '/sis-core/api/parent',
  MDS: '/mds/',

  MESSAGING: {
    COMPOSE_MESSAGE: 'messaging-service/api/message',
  },

  SURVEY: {
    SURVEY_CONFIG: 'survey-service/api/survey-config',
    SURVEY_DETAIL: 'survey-service/api/survey',
    PUBLIC_SURVEY: 'survey-service/api/survey/public',
    SURVEY_USER_DATA: 'survey-service/api/survey-user-data',
    PUBLIC_SURVEY_USER_DATA: 'survey-service/api/survey-user-data/public',
  },
  ENROLLMENT_DETAILS: '/lms-core/api/course-instance',
}

export const MEDIAMANAGERDOWNLOADAPI = '/media-manager/api/access/'
